import React from 'react';
import { Box } from '@mui/material';
import IconButton from '../icon_button/iconButton';
import PropTypes from 'prop-types';

/**
 * `SocialsGroup` is a component that renders a group of social media icons.
 */
export default function SocialsGroup({ color, size, socialIcons }) {

  const handleClick = (url) => {
    window.open(url, '_blank');
  }

  return (
    <Box sx={{ display: 'flex', gap: { xs: 0, lg: 0.7 }, position: 'relative', zIndex: '9' }}>
      {socialIcons.map((icon, index) => {
        if (socialIcons.length - 1 != index) {
          return (
            <IconButton
              key={index}
              color={color}
              size={size}
              type={icon.type}
              sx={{ py: { lg: '0 !important' } }}
              onClick={() => handleClick(icon?.url)}
            />
          )
        } else {
          return (
            <IconButton
              key={index}
              color={color}
              size={size}
              type={icon.type}
              sx={{ pr: { lg: '0 !important' }, py: { lg: '0 !important' } }}
              onClick={() => handleClick(icon?.url)}
            />
          )
        }
      }

      )}
    </Box>
  );
}

SocialsGroup.propTypes = {
  /**
   * The color of all icons in the group.
   *
   * Accepts a string representing a color name (`'primary'`, `'secondary'`) or a valid CSS color value.
   */
  color: PropTypes.oneOfType([
    PropTypes.oneOf(['primary', 'secondary']),
    PropTypes.string,
  ]),
  /**
   * The size of all icons in the group.
   *
   * Can be one of the predefined sizes (`'small'`, `'medium'`, `'large'`), a string with a specific size (e.g., `'40px'`).
   */
  size: PropTypes.oneOfType([
    PropTypes.oneOf(['small', 'medium', 'large']),
    PropTypes.string,
  ]),
  /**
   * Dynamically fetched array of social icons data object.
   */
  socialIcons: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,  // Ensuring type is a required string
      // You can add more properties for the icons if needed
    })
  ).isRequired,
};
